<template>
  <v-list dense>
    <c-item
      v-for="(item, index) in topics"
      :key="index"
      :item="item"
    />
  </v-list>
</template>

<script>
import CItem from './CItem'

export default {
  name: 'CTopics',
  components: {
    CItem
  },
  props: {
    topics: {
      type: Array,
      required: true
    }
  }
}
</script>
